import { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import DatePicker from "react-multi-date-picker";

import axios from 'axios';
import moment from 'moment';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const baseURL = process.env.REACT_APP_API_BASE_URL;


const EditSubscription = ({ show, onClose, data, refresh }) => {

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const user_id = parseInt(localStorage.getItem("user_id"), 10);
    const [locationUrl, setLocationUrl] = useState('');
    const [latitude, setlatitude] = useState(null);
    const [longitude, setlongitude] = useState(null);
    

    const [areaOption, setAreaOption] = useState([]);
    const [selectedArea, setSelectedArea] = useState([]);
    const [area, setArea] = useState(null);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
              const response = await axios.get(`${baseURL}/dropdown/area`, {params: {branch_id: branch_id}});
              const formattedsource = response.data.data.map(item => ({
                value: item.sno,
                label: item.area_name,
              }));
              setAreaOption(formattedsource);
            } catch (error) {
                console.log('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    const fetcharea = async (id) => {
        try {
            const response = await axios.get(`${baseURL}/dropdown/dparea/${id}`);
            const formattedsource = response.data.data.map(item => ({
                value: item.sno,
                label: item.name,
            }));
            setAreaOption(formattedsource);
            setArea(null);
            setSelectedArea([]);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if (area) {
            const preselected = areaOption.filter(option => option.value === area);
            // console.log(preselected);
            setSelectedArea(preselected);
        }
    }, [area, areaOption]);

    const handleareachange = (selectedOption) => {
        setSelectedArea(selectedOption);
        setArea(selectedOption.value);
    };

    // delivery point dropdown
    const [dppoption, setdpoption] = useState([]);
    const [dp, setDp] = useState(null);
    const [selecteddp, setselecteddp] = useState(null);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
              const response = await axios.get(`${baseURL}/dropdown/deliverypoint`, {params: {branch_id: branch_id}});
              const formattedsource = response.data.data.map(item => ({
                value: item.sno,
                label: item.delivery_point,
              }));
              setdpoption(formattedsource);
            } catch (error) {
                console.log('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    useEffect(() => {
        if (dp) {
            const preselected = dppoption.filter(option => option.value === dp);
            // console.log(preselected);
            setselecteddp(preselected);
        }
    }, [dp, dppoption]);

    // old dp change code
    // const handlechangedp = (selectedOption) => {
    //     setselecteddp(selectedOption);
    //     setDp(selectedOption.value);
    // };

    const [address, setAddress] = useState('');
    const [subscriberID, setSubscriberID] = useState(null);
    const [addresses, setAddressess] = useState([]);
    const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [datas, setdatas] = useState([]);
    const [newDate, setNewDate] = useState(new Date().toISOString().slice(0, 10));
    const [newDateDisp, setNewDateDisp] = useState(() => {
        const d = new Date();
        return `${String(d.getDate()).padStart(2, '0')}-${String(d.getMonth()+1).padStart(2, '0')}-${d.getFullYear()}`;
    });

    useEffect(() => {
        if (data) {
            setAddress(data.address);
            setSubscriberID(data.subscriber);
            setArea(data.area);
            setDp(data.delivery_point);
            setLocationUrl(data.location_url);
            setlatitude(data.latitude);
            setlongitude(data.longitude);
        }
    }, [data]);

    useEffect(() => {
        const fetchleaddetails = async () => {
            try {
                const response = await axios.get(`${baseURL}/subscriber/profile/${subscriberID}`);
                setdatas(response.data);
            } catch (error) {
                console.log('Error fetching data', error);
            }
        };
        if (subscriberID) {
            fetchleaddetails();
        }
    }, [subscriberID]);

    useEffect(() => {
        if (datas?.multiple_address && Array.isArray(datas.multiple_address)) {
            const formatted = datas.multiple_address.map((item, index) => ({
                value: index,
                label: item.address,
            }));
            setAddressess(formatted);
        }
    }, [datas]);

    useEffect(() => {
        const matchedOption = addresses.find((item) => item.label === address);
        if (matchedOption) {
            setSelectedOption(matchedOption);
            setIsChecked(false); // If the address exists in the list, set isChecked to true
            setIsCheckboxChecked(false);
        } else {
            setIsChecked(true); // Otherwise, set isChecked to false
            setIsCheckboxChecked(true);
        }
    }, [address, addresses]); 

    const [selectedOption, setSelectedOption] = useState(null);
    
    const handleCheckboxChange = (e) => {
        setIsChecked(e.target.checked);
        setIsCheckboxChecked(e.target.checked);
    };

    const handleSelectChange = (selected) => {
        setSelectedOption(selected);
        setAddress(selected ? selected.label : '');  // Set address to the selected option's label
    };

    const cus_dt = () => {
        return { backgroundColor: '#e9ecef', marginTop: '0px', marginBottom: '0px' };
    };
    
    
    const formatName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };

    const [latLng, setLatLng] = useState(null);
    // Extract lat/lng from pasted URL
    const extractLatLngFromUrl = (url) => {
        const match = url.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
        if (match) {
            setlatitude(parseFloat(match[1]));
            setlongitude(parseFloat(match[2]));
            return {
                lat: parseFloat(match[1]),
                lng: parseFloat(match[2]),
            };
        }
        return null;
    };

    useEffect(() => {
        if(locationUrl) {
            const coords = extractLatLngFromUrl(locationUrl);
            if (coords) {
                setLatLng(coords);
                errors.loc = "";
            } else {
                setLatLng(null);
                errors.loc = "Not a Valid Location URL.";
            }
        }
    }, [locationUrl]);

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};
        if (isChecked) {
            if (!address) {
                newErrors.addrs = "This Field is Required.";
            }
        } else {
            if (!selectedOption) {
                newErrors.sel = "This Field is Required.";
            }
        }

        if(locationUrl) {
            const coords = extractLatLngFromUrl(locationUrl);
            if (!coords) {
                newErrors.loc = "Not a Valid Location URL.";
            }
        } else {
            newErrors.loc = "This Field is Required.";
        }

        if(!area){
            newErrors.area = "This Field is Required.";
        }

        if(!dp){
            newErrors.dp = "This Field is Required.";
        }
        
        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        
        const postData = {
            area: area,
            delivery_point: dp,
            // start_date: data.start_date,
            // end_date: data.end_date,
            address: address,
            new_address_start_date: newDate,
            location_url: locationUrl,
            latitude: latitude,
            longitude: longitude,
            updated_by: user_id,
        }
        axios.put(`${baseURL}/leadsubscription/${data.sno}`, postData)
            .then(response => {
                onClose();
                refresh();
                toast.success("Subscription Updated Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Subscription Updation Failed");
            });
    };

    return (
        <Modal show={show} size="md"  >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Subscriptions</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <form onSubmit={handleSubmit}>
                    <div className="row mb-3">
                        <div className='col-lg-12 mb-3'>
                            <label className="text-black font-w500 fs-7">Products<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="" defaultValue={data.product_name} readOnly />
                        </div>
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">Start Date<span className="required">*</span></label>
                            <div className='datepicker-wrapper d-flex'>
                                <div className='input-group-text border-0 px-0 bg-gray-200 rounded-bottom-end-0 rounded-top-end-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                <DatePicker placeholder='Select Start Date' disabled
                                    value={moment(data.start_date).format("DD-MM-YYYY")}
                                    format="DD-MM-YYYY"
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 mb-3">
                            <label className="text-black font-w500 fs-7">End Date</label>
                            <div className='datepicker-wrapper d-flex'>
                                <div className='input-group-text border-0 px-0 bg-gray-200 rounded-bottom-end-0 rounded-top-end-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                <DatePicker placeholder='Select End Date'
                                    disabled
                                    value={moment(data.end_date).format("DD-MM-YYYY")}
                                    format="DD-MM-YYYY"
                                    style={cus_dt()}
                                />
                            </div>
                        </div>

                        <div className="col-lg-12 mb-2 d-flex justify-content-between align-items-center">
                            <label className="text-black font-w500 fs-7">
                                {isChecked ? 'Custom Address' : 'Address' }<span className="required">*</span>
                            </label>

                            <label className="text-black font-w500 fs-7 mb-2 d-flex justify-content-end">
                                <input
                                    type="checkbox"
                                    onChange={handleCheckboxChange}
                                    className="form-check-input me-2"
                                    id="customCheckBox1"
                                    checked={isCheckboxChecked}
                                />
                                Custom Address
                            </label>
                        </div>

                        {isChecked && (
                            <div className="col-lg-12 mb-3">
                                <textarea className="form-control" placeholder="Enter Address"
                                    maxLength={250}
                                    value={address} 
                                    onChange={(e) => setAddress(formatName(e.target.value))} 
                                />
                                {errors.addrs && <div className="text-danger fs-8 mt-1">{errors.addrs}</div>}
                            </div>
                        )}
                        {!isChecked && (
                            <div className="col-lg-12 mb-3">
                                <Select placeholder='Select Address'
                                    value={selectedOption}
                                    onChange={handleSelectChange}
                                    options={addresses}
                                />
                                {errors.sel && <div className="text-danger fs-8 mt-1">{errors.sel}</div>}
                            </div>
                        )}

                        <div className="col-lg-12 mb-4">
                            <label className="text-black font-w500 fs-7">Location URL <span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Paste Google Maps location URL" value={locationUrl} onChange={(e) => setLocationUrl(e.target.value)}/>
                            {errors.loc && <div className="text-danger fs-8 mt-1">{errors.loc}</div>}
                        </div>
 
                        <div className="col-lg-12 mb-3">
                            <label className="text-black font-w500 fs-7">New Address Start Date<span className="required">*</span></label>
                            <div className='datepicker-wrapper d-flex'>
                                <div className='input-group-text bg-transparent border-0 px-0 rounded-bottom-end-0 rounded-top-end-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                <DatePicker placeholder='Select Start Date'
                                    value={newDateDisp}
                                    onChange={(Date) => {
                                        setNewDateDisp(Date);
                                        const formattedDate = Date.format('YYYY-MM-DD');
                                        setNewDate(formattedDate);
                                    }}
                                    format="DD-MM-YYYY"
                                />
                            </div>
                        </div>
                        
                        <div className='col-lg-6 mb-3'>
                            <label className="text-black font-w500 fs-7">Delivery Point<span className="required">*</span></label>
                            <Select placeholder='Select Delivery Point'
                                value={selecteddp}
                                // onChange={handlechangedp}
                                onChange={(selectedOption) => {
                                    setselecteddp(selectedOption);
                                    setDp(selectedOption.value);
                                    fetcharea(selectedOption.value);
                                }}
                                options={dppoption}
                            />
                            {errors.dp && <div className="text-danger fs-8 mt-1">{errors.dp}</div>}
                        </div>
                        <div className='col-lg-6 mb-3'>
                            <label className="text-black font-w500 fs-7">Area<span className="required">*</span></label>
                            <Select placeholder='Select Area'
                                value={selectedArea}
                                onChange={handleareachange}
                                options={areaOption}
                            />
                            {errors.area && <div className="text-danger fs-8 mt-1">{errors.area}</div>}
                        </div>
                        
                        
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                        {/* <Link className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link> */}
                        <button className="btn btn-sm btn-primary">Update Subscriptions<i className="fas fa-angle-double-right ms-2"></i></button>
                    </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};

export default EditSubscription;
